import appTag from "../../views/appSettings/tag.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("tag", {
    url: "tag/:id",
    parent: "app",
    views: {
      view: {
        template: appTag,
      },
    },
    reloadOnSearch: false,
    data: { title: "Tag" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/tag/tag.urls.js